<template>
    <div style="padding:10px">
        <el-row>
            <el-button-group>
                <el-button round type="success" @click="openCreate">创建</el-button>
            </el-button-group>
        </el-row>

        <el-row style="padding:20px 0">
            <el-col :span="24">
                <el-table :data="dataViewList" style="width: 100%">
                    <el-table-column label="状态" width="100">
                        <template #default="scope">
                            <el-tag v-if="scope.row.isEnable" size="medium" type="success">启用</el-tag>
                            <el-tag v-else size="medium" type="danger">停用</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column prop="name" label="视图名称" width="220"></el-table-column>
                    <el-table-column prop="description" label="描述信息"></el-table-column>
                    <el-table-column prop="sort" label="排序" width="100"></el-table-column>
                    <el-table-column prop="createTime" label="创建时间" width="180"></el-table-column>
                    <el-table-column fixed="right" label="操作" width="220">
                        <template #default="scope">
                            <el-button @click="openEdit(scope.row)" type="text" size="small">编辑</el-button>
                            <el-button @click="toggleEnable(scope.row)" type="text" size="small">启用/停用</el-button>

                            <el-popover placement="top-start" :width="200" trigger="click">
                                <p>删除操作不可撤回，确定删除吗？</p>
                                <div style="text-align: right; margin: 0">
                                    <el-button type="danger" size="mini" @click="remove(scope.row)">确定</el-button>
                                </div>
                                <template #reference>
                                    <el-button type="text" size="small">删除</el-button>
                                </template>
                            </el-popover>
                        </template>
                    </el-table-column>
                </el-table>
            </el-col>
        </el-row>
    </div>

    <!-- Form -->
    <el-dialog :title="dialogFormMode == 'create' ? '创建数据视图' : '编辑数据视图'" v-model="dialogFormVisible"
        width="80%" top="5vh" :close-on-click-modal="false">
        <el-tabs v-model="activeTab">
            <el-tab-pane label="基本信息" name="base">
                <div class="info-section">
                    <div class="info-section-title">基本信息</div>
                    <div class="info-section-body">
                        <el-form :model="dataForm" label-width="100px">
                            <el-form-item label="视图名称">
                                <el-input v-model="dataForm.name" autocomplete="off"></el-input>
                            </el-form-item>
                            <el-form-item label="描述信息">
                                <el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="dataForm.description">
                                </el-input>
                            </el-form-item>
                            <el-form-item label="排序">
                                <el-input-number v-model="dataForm.sort" :min="0"></el-input-number>
                            </el-form-item>
                            <el-form-item label="运行状态">
                                <el-switch v-model="dataForm.isEnable" active-color="#13ce66" inactive-color="#ff4949">
                                </el-switch>
                            </el-form-item>
                        </el-form>
                    </div>
                </div>

                <div class="info-section">
                    <div class="info-section-title">样式</div>
                    <div class="info-section-body">
                        <el-form :model="dataForm.style" label-width="100px">
                            <el-form-item label="头像">
                                <el-input v-model="dataForm.style.avatar" placeholder="头像地址"></el-input>
                            </el-form-item>
                            <el-form-item label="背景">
                                <el-input v-model="dataForm.style.background" placeholder="背景图地址"></el-input>
                            </el-form-item>
                        </el-form>
                    </div>
                </div>

                <div class="info-section">
                    <div class="info-section-title">数据库源</div>
                    <div class="info-section-body">
                        <el-button type="success" size="small" @click="addSrcDb">添加数据库源</el-button>
                        <div v-for="(item, index) in dataForm.srcDbs" :key="index" class="jsonb-item">
                            <el-row :gutter="10">
                                <el-col :span="6"><el-input v-model="item.name" placeholder="名称" /></el-col>
                                <el-col :span="6"><el-input v-model="item.url" placeholder="URL" /></el-col>
                                <el-col :span="6">
                                    <el-select v-model="item.type" placeholder="类型" clearable style="width:100%">
                                        <el-option label="MySQL" value="mysql"></el-option>
                                        <el-option label="PostgreSQL" value="postgresql"></el-option>
                                    </el-select>
                                </el-col>
                                <el-col :span="6"><el-input v-model="item.driverClass" placeholder="驱动类" /></el-col>
                            </el-row>
                            <el-row :gutter="10" style="margin-top:10px">
                                <el-col :span="8"><el-input v-model="item.userName" autocomplete="off" placeholder="用户名" /></el-col>
                                <el-col :span="8"><el-input v-model="item.password" type="password" show-password
                                        autocomplete="new-password" placeholder="密码" /></el-col>
                                <el-col :span="8"><el-input v-model="item.remark" placeholder="备注" /></el-col>
                            </el-row>
                            <el-button type="danger" size="small" style="margin-top:10px"
                                @click="removeItem(dataForm.srcDbs, index)">删除</el-button>
                        </div>
                    </div>
                </div>

                <div class="info-section">
                    <div class="info-section-title">SSH源</div>
                    <div class="info-section-body">
                        <el-button type="success" size="small" @click="addSrcSsh">添加SSH源</el-button>
                        <div v-for="(item, index) in dataForm.srcSshs" :key="index" class="jsonb-item">
                            <el-row :gutter="10">
                                <el-col :span="8"><el-input v-model="item.name" placeholder="名称" /></el-col>
                                <el-col :span="8"><el-input v-model="item.ip" placeholder="IP" /></el-col>
                                <el-col :span="8"><el-input v-model="item.port" placeholder="端口" /></el-col>
                            </el-row>
                            <el-row :gutter="10" style="margin-top:10px">
                                <el-col :span="8"><el-input v-model="item.userName" autocomplete="off" placeholder="用户名" /></el-col>
                                <el-col :span="8"><el-input v-model="item.password" type="password" show-password
                                        autocomplete="new-password" placeholder="密码" /></el-col>
                                <el-col :span="8"><el-input v-model="item.remark" placeholder="备注" /></el-col>
                            </el-row>
                            <el-button type="danger" size="small" style="margin-top:10px"
                                @click="removeItem(dataForm.srcSshs, index)">删除</el-button>
                        </div>
                    </div>
                </div>

                <div class="info-section">
                    <div class="info-section-title">URL源</div>
                    <div class="info-section-body">
                        <el-button type="success" size="small" @click="addSrcUrl">添加URL源</el-button>
                        <div v-for="(item, index) in dataForm.srcUrls" :key="index" class="jsonb-item">
                            <el-row :gutter="10">
                                <el-col :span="8"><el-input v-model="item.name" placeholder="名称" /></el-col>
                                <el-col :span="8"><el-input v-model="item.url" placeholder="URL" /></el-col>
                                <el-col :span="8"><el-input v-model="item.type" placeholder="类型" /></el-col>
                            </el-row>
                            <el-row :gutter="10" style="margin-top:10px">
                                <el-col :span="24"><el-input v-model="item.remark" placeholder="备注" /></el-col>
                            </el-row>
                            <el-button type="danger" size="small" style="margin-top:10px"
                                @click="removeItem(dataForm.srcUrls, index)">删除</el-button>
                        </div>
                    </div>
                </div>

                <div class="info-section">
                    <div class="info-section-title">团队</div>
                    <div class="info-section-body">
                        <el-select v-model="dataForm.teamIdList" multiple filterable placeholder="选择团队" style="width:100%">
                            <el-option v-for="team in ownerTeams" :key="team.id" :label="team.name"
                                :value="team.id"></el-option>
                        </el-select>
                    </div>
                </div>
            </el-tab-pane>

            <el-tab-pane label="区块" name="sections">
                <div style="margin-bottom:10px">
                    <el-button type="success" size="small" @click="addSection">添加区块</el-button>
                    <el-switch v-model="sectionDragEnable" active-text="拖动排序" style="margin-left:10px"></el-switch>
                    <span class="tips">开启后可拖动排序区块、卡片，卡片可跨区块移动</span>
                </div>
                <el-tree class="dv-tree" :data="dataForm.sections" node-key="_id" :props="treeProps" default-expand-all
                    :expand-on-click-node="false" :draggable="sectionDragEnable" :allow-drop="allowDrop">
                    <template #default="{ node, data }">
                        <div v-if="data.cards !== undefined" class="tree-edit-section">
                            <el-row :gutter="8">
                                <el-col :span="10"><el-input v-model="data.name" placeholder="区块名称" size="small" /></el-col>
                                <el-col :span="10"><el-input v-model="data.remark" placeholder="备注" size="small" /></el-col>
                                <el-col :span="4" style="text-align:right">
                                    <el-button size="small" type="danger" @click.stop="removeSection(data)">删除</el-button>
                                </el-col>
                            </el-row>
                        </div>
                        <div v-else-if="data._isAdd" class="tree-edit-card tree-add-card">
                            <el-button type="primary" size="small" @click.stop="addCard(node.parent.data)">+ 添加卡片</el-button>
                        </div>
                        <div v-else class="tree-edit-card">
                            <el-row :gutter="8">
                                <el-col :span="5"><el-input v-model="data.name" placeholder="卡片名称" size="small" /></el-col>
                                <el-col :span="5">
                                    <el-select v-model="data.type" placeholder="卡片类型" clearable size="small" style="width:100%">
                                        <el-option v-for="t in cardTypeOptions" :key="t.value" :label="t.label" :value="t.value">
                                            <el-tooltip :content="t.desc" placement="right">
                                                <span>{{ t.label }}</span>
                                            </el-tooltip>
                                        </el-option>
                                    </el-select>
                                </el-col>
                                <el-col :span="12">
                                    <el-cascader v-model="data._src" :options="srcCascaderOptions"
                                        placeholder="数据源" clearable size="small"
                                        style="width:100%" @change="v => onCascaderChange(data, v)" />
                                </el-col>
                                <el-col :span="2" style="text-align:right">
                                    <el-button size="small" type="danger" @click.stop="removeCard(data)">删除</el-button>
                                </el-col>
                            </el-row>
                            <el-row :gutter="8" style="margin-top:6px">
                                <el-col :span="24">
                                    <el-input v-model="data.paramsText" type="textarea" :rows="3"
                                        placeholder="参数(JSON格式)" size="small" />
                                </el-col>
                            </el-row>
                            <el-row :gutter="8" style="margin-top:6px">
                                <el-col :span="24"><el-input v-model="data.remark" placeholder="备注" size="small" /></el-col>
                            </el-row>
                        </div>
                    </template>
                </el-tree>
            </el-tab-pane>
        </el-tabs>

        <template #footer>
            <span class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="save">保 存</el-button>
            </span>
        </template>
    </el-dialog>
</template>

<script>
import { ElMessage } from 'element-plus';
import request from '../../../utils/request.js';

function emptyDataForm() {
    return {
        name: '',
        description: '',
        sort: 0,
        isEnable: false,
        style: { avatar: '', background: '' },
        srcDbs: [],
        srcSshs: [],
        srcUrls: [],
        sections: [],
        teamIdList: []
    };
}

export default {
    data() {
        return {
            dialogFormMode: 'create',
            dialogFormVisible: false,
            activeTab: 'base',
            dataForm: emptyDataForm(),
            currentId: '',
            dataViewList: [],
            ownerTeams: [],
            treeSeq: 0,
            sectionDragEnable: true,
            treeProps: { children: 'cards', label: 'name' },
            cardTypeOptions: [
                { value: 'card-chart-bar', label: '横向柱状图', desc: '条形图，柱子水平摆放' },
                { value: 'card-chart-column', label: '纵向柱状图', desc: '柱形图，柱子垂直摆放' },
                { value: 'card-chart-line', label: '折线图', desc: '趋势折线图表' },
                { value: 'card-chart-pie', label: '饼图', desc: '占比饼状图表' },
                { value: 'card-text', label: '文本', desc: '纯文字/指标文本展示卡片' }
            ]
        };
    },
    mounted() {
        this.loadList();
        this.loadOwnerTeams();
    },
    computed: {
        srcCascaderOptions() {
            const build = list => list.map(x => ({ value: x.id, label: x.name || x.id }));
            const make = (value, label, list) => {
                const children = build(list);
                return { value, label, children, disabled: children.length === 0 };
            };
            return [
                make('db', '数据库', this.dataForm.srcDbs),
                make('ssh', 'SSH', this.dataForm.srcSshs),
                make('url', 'URL', this.dataForm.srcUrls)
            ];
        }
    },
    methods: {
        loadList() {
            return request({
                url: '/dataview/list',
                method: 'post',
                data: {}
            }).then(res => {
                if (res.code == 0) {
                    this.dataViewList = res.meta.dataViews || [];
                }
            });
        },
        loadOwnerTeams() {
            return request({
                url: '/team/getOwnerTeams',
                method: 'post',
                data: {}
            }).then(res => {
                if (res.code == 0) {
                    this.ownerTeams = res.data || [];
                }
            });
        },
        openCreate() {
            this.dialogFormMode = 'create';
            this.currentId = '';
            this.dataForm = emptyDataForm();
            this.activeTab = 'base';
            this.dialogFormVisible = true;
        },
        openEdit(row) {
            this.dialogFormMode = 'edit';
            this.currentId = row.id;
            this.dataForm = this.toEditForm(row);
            this.activeTab = 'base';
            this.dialogFormVisible = true;
        },
        toEditForm(row) {
            return {
                name: row.name || '',
                description: row.description || '',
                sort: row.sort || 0,
                isEnable: !!row.isEnable,
                style: row.style || { avatar: '', background: '' },
                srcDbs: (row.srcDbs || []).map(x => ({ ...x })),
                srcSshs: (row.srcSshs || []).map(x => ({ ...x })),
                srcUrls: (row.srcUrls || []).map(x => ({ ...x })),
                sections: (row.sections || []).map(s => ({
                    _id: this.genId(),
                    name: s.name || '',
                    remark: s.remark || '',
                    cards: (s.cards || []).map(c => ({
                        _id: this.genId(),
                        name: c.name || '',
                        type: c.type || '',
                        srcId: c.srcId || '',
                        srcType: c.srcType || '',
                        _src: c.srcType ? (c.srcId ? [c.srcType, c.srcId] : [c.srcType]) : [],
                        paramsText: c.params ? JSON.stringify(c.params, null, 2) : '',
                        remark: c.remark || ''
                    })).concat([this.addButtonCard()])
                })),
                teamIdList: row.teamIdList || []
            };
        },
        toSubmitData() {
            const form = this.dataForm;
            return {
                name: form.name,
                description: form.description,
                sort: form.sort,
                isEnable: form.isEnable,
                style: form.style,
                srcDbs: form.srcDbs,
                srcSshs: form.srcSshs,
                srcUrls: form.srcUrls,
                sections: form.sections.map(s => ({
                    name: s.name,
                    remark: s.remark,
                    cards: s.cards.filter(c => !c._isAdd).map(c => ({
                        name: c.name,
                        type: c.type,
                        srcId: c.srcId,
                        srcType: c.srcType,
                        params: c.paramsText && c.paramsText.trim() ? JSON.parse(c.paramsText) : null,
                        remark: c.remark
                    }))
                })),
                teamIdList: form.teamIdList
            };
        },
        save() {
            let data;
            try {
                data = this.toSubmitData();
            } catch (e) {
                ElMessage({ message: '卡片参数格式错误，请填写合法的 JSON', type: 'error', duration: 3 * 1000 });
                return;
            }

            if (this.dialogFormMode == 'create') {
                return request({
                    url: '/dataview/create',
                    method: 'post',
                    data: data
                }).then(res => {
                    if (res.code == 0) {
                        this.dialogFormVisible = false;
                        this.loadList();
                    }
                });
            }
            if (this.dialogFormMode == 'edit') {
                return request({
                    url: '/dataview/edit',
                    method: 'post',
                    data: Object.assign({ id: this.currentId }, data)
                }).then(res => {
                    if (res.code == 0) {
                        this.dialogFormVisible = false;
                        this.loadList();
                    }
                });
            }
        },
        toggleEnable(row) {
            return request({
                url: '/dataview/enable',
                method: 'post',
                data: { id: row.id, enable: !row.isEnable }
            }).then(res => {
                if (res.code == 0) {
                    this.loadList();
                }
            });
        },
        remove(row) {
            return request({
                url: '/dataview/delete',
                method: 'post',
                data: { id: row.id }
            }).then(res => {
                if (res.code == 0) {
                    this.loadList();
                }
            });
        },
        addSrcDb() {
            this.dataForm.srcDbs.push({
                id: this.nextId(this.dataForm.srcDbs), name: '', url: '', type: '', userName: '',
                password: '', driverClass: '', remark: ''
            });
        },
        addSrcSsh() {
            this.dataForm.srcSshs.push({
                id: this.nextId(this.dataForm.srcSshs), name: '', ip: '', port: '', userName: '',
                password: '', remark: ''
            });
        },
        addSrcUrl() {
            this.dataForm.srcUrls.push({ id: this.nextId(this.dataForm.srcUrls), name: '', url: '', type: '', remark: '' });
        },
        nextId(list) {
            let max = 0;
            list.forEach(item => {
                const n = parseInt(item.id, 10);
                if (!isNaN(n) && n > max) max = n;
            });
            return String(max + 1);
        },
        onCascaderChange(card, value) {
            if (Array.isArray(value) && value.length > 0) {
                card.srcType = value[0];
                card.srcId = value.length > 1 ? value[1] : '';
            } else {
                card.srcType = '';
                card.srcId = '';
            }
        },
        addSection() {
            this.dataForm.sections.push({
                _id: this.genId(), name: '', remark: '',
                cards: [this.addButtonCard()]
            });
        },
        addCard(section) {
            const card = {
                _id: this.genId(), name: '', type: '', srcId: '', srcType: '', _src: [],
                paramsText: '', remark: ''
            };
            const addIdx = section.cards.findIndex(c => c._isAdd);
            if (addIdx >= 0) section.cards.splice(addIdx, 0, card);
            else section.cards.push(card);
        },
        addButtonCard() {
            return { _id: this.genId(), _isAdd: true };
        },
        removeItem(list, index) {
            list.splice(index, 1);
        },
        removeSection(data) {
            const idx = this.dataForm.sections.findIndex(s => s._id === data._id);
            if (idx >= 0) this.dataForm.sections.splice(idx, 1);
        },
        removeCard(data) {
            if (data._isAdd) return;
            for (const section of this.dataForm.sections) {
                const idx = section.cards.findIndex(c => c._id === data._id);
                if (idx >= 0) {
                    section.cards.splice(idx, 1);
                    return;
                }
            }
        },
        genId() {
            this.treeSeq += 1;
            return 'n' + this.treeSeq;
        },
        allowDrop(draggingNode, dropNode, type) {
            if (draggingNode.data._isAdd || dropNode.data._isAdd) return false;
            const draggingIsSection = draggingNode.data && draggingNode.data.cards !== undefined;
            const dropIsSection = dropNode.data && dropNode.data.cards !== undefined;
            if (draggingIsSection) {
                // 区块只能与区块同级排序，不允许拖入区块内部或卡片层级
                return dropIsSection && type !== 'inner';
            }
            if (dropIsSection) {
                // 卡片只能拖入区块内部（实现跨区块移动）
                return type === 'inner';
            }
            // 卡片与卡片之间仅允许同级排序
            return type !== 'inner';
        }
    }
};
</script>

<style>
.el-main {
    text-align: left;
}

.info-section {
    border: 1px solid #e4e7ed;
    border-radius: 6px;
    margin-bottom: 14px;
    background: #fff;
    overflow: hidden;
}

.info-section-title {
    font-weight: bold;
    padding: 8px 14px;
    background: #f5f7fa;
    border-bottom: 1px solid #e4e7ed;
    color: #303133;
}

.info-section-body {
    padding: 14px;
}

.jsonb-item {
    border: 1px solid #ebeef5;
    border-radius: 4px;
    padding: 10px;
    margin-top: 10px;
}

.dv-tree .el-tree-node__content {
    height: auto;
    min-height: 36px;
    padding: 4px 0;
}

.tree-edit-section,
.tree-edit-card {
    flex: 1;
    width: 100%;
    border-radius: 4px;
    padding: 6px 8px;
    box-sizing: border-box;
}

.tree-edit-section {
    background: #ecf5ff;
    border: 1px solid #b3d8ff;
    margin-top: 8px;
}

.tree-edit-card {
    background: #fafafa;
    border: 1px solid #ebeef5;
    border-left: 3px solid #409eff;
    margin-top: 4px;
}

.tree-add-card {
    background: transparent;
    border: 1px dashed #c0c4cc;
    border-left: 1px dashed #c0c4cc;
    text-align: center;
}

.tips {
    font-size: 12px;
    color: #909399;
    margin-left: 10px;
}
</style>
